import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FulFillOrderCarouselComponent from "./FulFillOrderCarouselComponent";
import OrderTrackingsCarouselComponent from "./OrderTrackingsCarouselComponent";
import ProductCardCarouselComponent from "./ProductCardCarouselComponent";
export default function LoginCarousel() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    // autoplaySpeed:2000,
    autoplay:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <></>, // Use empty fragment to hide previous button
    nextArrow: <></>,
  };

  return (
    <Slider {...settings}>
      <div style={{height:"100%"}}>
        <FulFillOrderCarouselComponent />
      </div>
      <div style={{height:"100%"}}>
        <OrderTrackingsCarouselComponent />
      </div>
      <div style={{height:"100%"}}>
       <ProductCardCarouselComponent />
      </div>
    </Slider>
  );
}
